// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Maximize = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Maximize = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Maximize = _exports.Maximize = function Maximize(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.2904 3.33203V7.4987C17.2904 7.8437 17.0104 8.1237 16.6654 8.1237C16.3204 8.1237 16.0404 7.8437 16.0404 7.4987V4.84123L9.60706 11.2745C9.48539 11.3962 9.32537 11.4578 9.16536 11.4578C9.00536 11.4578 8.84534 11.397 8.72367 11.2745C8.47951 11.0304 8.47951 10.6345 8.72367 10.3903L15.157 3.95703H12.4987C12.1537 3.95703 11.8737 3.67703 11.8737 3.33203C11.8737 2.98703 12.1537 2.70703 12.4987 2.70703H16.6654C16.747 2.70703 16.828 2.72379 16.9046 2.75545C17.0571 2.81879 17.1788 2.94046 17.243 3.09379C17.2738 3.16962 17.2904 3.25036 17.2904 3.33203ZM16.6654 10.207C16.3204 10.207 16.0404 10.487 16.0404 10.832V14.1654C16.0404 15.4795 15.4795 16.0404 14.1654 16.0404H5.83203C4.51786 16.0404 3.95703 15.4795 3.95703 14.1654V5.83203C3.95703 4.51786 4.51786 3.95703 5.83203 3.95703H9.16536C9.51037 3.95703 9.79036 3.67703 9.79036 3.33203C9.79036 2.98703 9.51037 2.70703 9.16536 2.70703H5.83203C3.81703 2.70703 2.70703 3.81703 2.70703 5.83203V14.1654C2.70703 16.1804 3.81703 17.2904 5.83203 17.2904H14.1654C16.1804 17.2904 17.2904 16.1804 17.2904 14.1654V10.832C17.2904 10.487 17.0104 10.207 16.6654 10.207Z",
      fill: "#212B36"
    }));
  };
});
